import { createContext, useCallback, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HeaderBreadcrumbs from "./HeaderBreadcrumbs";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { Col, Row } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import AddIcon from "./GFSRulesIcon/AddIcon";
import EditPancilIcon from "./GFSRulesIcon/EditPancilIcon";
import Modal from "react-bootstrap/Modal";
import SearchIcon from "./GFSRulesIcon/SearchIcon";
import FeeRuleCard from "./GFSRulesCard/FeeRuleCard";
import MultiSelectWithSearch from "./GFSRulesCard/MultiSelectWithSearch";
import AddNewFeeRule from "./GFSRulesCard/AddNewFeeRule";
import { useSnackbar } from "notistack5";
import {
  addCarrierGroup,
  addFeeRule,
  addLocationGroup,
  addRuleIn,
  deleteFeeRule,
  downloadFile,
  editCarrier,
  editFeeRule,
  editLocation,
  getcarrierDropdownApi,
  getCarriers,
  getFeeRule,
  getLocations,
} from "src/Api/Services/GfsRule";
import { useForm } from "react-hook-form";
import { get } from "lodash";
import { ca, fi } from "date-fns/locale";
import { getCarrierName } from "src/utils/Currency";
import SpinnerLoader from "./GFSRulesCard/SpinnerLoader";
import { status } from "nprogress";
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];
export const GfsContext = createContext();
const GFSRules = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [carrierDropdown, setCarrierDropdown] = useState([]);
  const [locationGroupName, setLocationGroupName] = useState("");
  const [carrierGroupName, setCarrierGroupName] = useState("");
  const [selectedLocations, setSelectedLocations] = useState("");
  const [selectedCarriers, setSelectedCarriers] = useState("");
  const [locationList, setLocationList] = useState([]);
  const [carrierList, setCarrierList] = useState([]);
  const [editLocationId, setEditLocationId] = useState(null);
  const [editCarrierId, setEditCarrierId] = useState(null);
  const [showAddLocation, setShowAddLocation] = useState(false);
  const [airportDropdown, setAirportDropdown] = useState([]);
  const [carrierDropdown3, setCarrierDropdown3] = useState([]);
  const [feeRulesList, setFeeRulesList] = useState([]);
  const [allFeeRulesList, setAllFeeRulesList] = useState([]);
  const [editFeeRuleId, setEditFeeRuleId] = useState(null);
  const [fieldSearchText, setFieldSearchText] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [duplicateFeeRuleId, setDuplicateFeeRuleId] = useState(null);
  const [captcha, setCaptcha] = useState(null);
  const [enteredCaptcha, setEnteredCaptcha] = useState(null);
  const defaultFormValues = {
    carrier: "",
    sequenceNum: null,
    travelDateEffective: "",
    travelDateDiscontinue: "",
    ticketingDateEffective: "",
    ticketingDateDiscontinue: "",
    origin: "",
    destination: "",
    feeAmount: "",
    discountType: "",
    oncePerBookingFeeAmount: "",
    feePercent: "",
    suppress: "",
    minPrice: "",
    maxPrice: "",
    tripType: "",
    cabinClass: "",
    cabinClassMatchMode: "",
    passengerType: "",
    interline: "",
    sliceInterline: "",
    minSegments: null,
    minTotalSegments: null,
    maxHoursToDeparture: null,
    priceSource: "",
    feeAmtCrr: "",
    feeAmtPrice: "",
    oncePerBookingFeeAmtCurr: "",
    oncePerBookingFeeAmtPrice: "",
    minPriceCurr: "",
    minPriceAmt: "",
    feePercentDiscount: "",
    feePercentPrice: "",
    maxPriceCurr: "",
    maxPriceAmt: "",
    oncePerCheck: false,
    status: false,
  };
  const {
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: defaultFormValues,
  });
  const handleCloseAddLocation = () => {
    setSelectedLocations("");
    setLocationGroupName("");
    setShowAddLocation(false);
  };
  const handleShowAddLocation = () => setShowAddLocation(true);

  const [showEditLocation, setShowEditLocation] = useState(false);

  const handleCloseEditLocation = () => {
    setSelectedLocations("");
    setLocationGroupName("");
    setShowEditLocation(false);
  };
  const handleShowEditLocation = (editItem) => {
    const val = editItem?.locationList?.map((loc) => loc?.id).join(", ");
    setEditLocationId(editItem?.tableNum);
    setSelectedLocations(val);
    setLocationGroupName(editItem?.name);
    setShowEditLocation(true);
  };

  const [showEditCarrier, setShowEditCarrier] = useState(false);
  const [addRuleInCRM, setAddRuleInCRM] = useState(false);

  function generateCaptcha() {
    return Math.floor(1000 + Math.random() * 9000);
  }

  useEffect(() => {
    if (addRuleInCRM) {
      const newCaptcha = generateCaptcha();
      setCaptcha(newCaptcha);
    }
  }, [addRuleInCRM]);
  const handleCloseEditCarrier = () => {
    setSelectedCarriers("");
    setCarrierGroupName("");
    setShowEditCarrier(false);
  };
  const handleShowEditCarrier = (editItem) => {
    const val = editItem?.carriers?.map((loc) => loc?.id).join(", ");
    setEditCarrierId(editItem?.tableNum);
    setSelectedCarriers(val);
    setCarrierGroupName(editItem?.name);
    setShowEditCarrier(true);
  };

  const [showAddCarrier, setShowAddCarrier] = useState(false);

  const handleCloseAddCarrier = () => {
    setCarrierGroupName("");
    setSelectedCarriers("");
    setShowAddCarrier(false);
  };
  const handleShowAddCarrier = () => setShowAddCarrier(true);

  const fetchLocationDropdown = async () => {
    const locationRes = await getcarrierDropdownApi(1);
    if (locationRes?.data?.httpStatusCodes === 200) {
      setLocationDropdown(locationRes.data.data);
    } else {
      enqueueSnackbar("Failed to fetch location dropdown", {
        variant: "error",
      });
    }

    const airportDropdownRes = await getcarrierDropdownApi(4);
    if (airportDropdownRes?.data?.httpStatusCodes === 200) {
      setAirportDropdown(airportDropdownRes.data.data);
    } else {
      enqueueSnackbar("Failed to fetch carrier dropdown", {
        variant: "error",
      });
    }
  };

  const fetchCarrierDropdown = async () => {
    try {
      const [
        locationListRes,
        carrierRes,
        carrierListRes,
        carrierDropdownRes3,
        feeRuleRes,
      ] = await Promise.all([
        getLocations(),
        getcarrierDropdownApi(2),
        getCarriers(),
        getcarrierDropdownApi(3),
        getFeeRule(),
      ]);

      if (locationListRes?.data?.httpStatusCodes === 200) {
        setLocationList(locationListRes.data.data);
      } else {
        enqueueSnackbar("Failed to fetch location list", {
          variant: "error",
        });
      }

      if (carrierRes?.data?.httpStatusCodes === 200) {
        setCarrierDropdown(carrierRes.data.data);
      } else {
        enqueueSnackbar("Failed to fetch carrier dropdown", {
          variant: "error",
        });
      }

      if (carrierListRes?.data?.httpStatusCodes === 200) {
        setCarrierList(carrierListRes.data.data);
      } else {
        enqueueSnackbar("Failed to fetch carrier list fghyfkyk", {
          variant: "error",
        });
      }

      if (carrierDropdownRes3?.data?.httpStatusCodes === 200) {
        setCarrierDropdown3(carrierDropdownRes3.data.data);
      } else {
        enqueueSnackbar("Failed to fetch carrier dropdown", {
          variant: "error",
        });
      }

      if (feeRuleRes?.data?.httpStatusCodes === 200) {
        setFeeRulesList(feeRuleRes.data.data);
        setAllFeeRulesList(feeRuleRes.data.data);
        setLoading(false);
      } else {
        enqueueSnackbar("Failed to fetch fee rule list", {
          variant: "error",
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Dropdown fetch error:", error);
      enqueueSnackbar("Network error: Could not fetch dropdown data", {
        variant: "error",
      });
    }
  };
  const [showAddFeeRule, setShowAddFeeRule] = useState(false);

  const handleCloseAddFeeRule = () => {
    setShowAddFeeRule(false);
    reset(defaultFormValues);
    setEditFeeRuleId(null);
    setDuplicateFeeRuleId(null);
  };
  const handleShowAddFeeRule = () => setShowAddFeeRule(true);

  useEffect(() => {
    fetchCarrierDropdown();
    fetchLocationDropdown();
  }, []);

  const handleAddLocation = async (e) => {
    e.preventDefault();
    if (selectedLocations.trim() === "" || locationGroupName.trim() === "") {
      enqueueSnackbar("Please fill all the fields", {
        variant: "warning",
      });
      return;
    }
    try {
      const res = await addLocationGroup({
        data: selectedLocations,
        name: locationGroupName.trim(),
      });

      if (res?.data?.httpStatusCodes === 200) {
        enqueueSnackbar(res.data.msg, { variant: "success" });
        handleCloseAddLocation();
        fetchCarrierDropdown();
      } else {
        enqueueSnackbar(res.data.msg, { variant: "error" });
      }
    } catch (error) {
      console.error("Error adding location:", error);
      enqueueSnackbar(`Network error: Could not add location`, {
        variant: "error",
      });
    }
  };

  const handleEditLocation = async (e) => {
    e.preventDefault();
    try {
      if (selectedLocations.trim() === "" || locationGroupName.trim() === "") {
        enqueueSnackbar("Please fill all the fields", {
          variant: "warning",
        });
        return;
      }

      const res = await editLocation(editLocationId, {
        data: selectedLocations,
        name: locationGroupName.trim(),
      });
      if (res?.data?.httpStatusCodes === 200) {
        enqueueSnackbar(res.data.msg, { variant: "success" });
        handleCloseEditLocation();
        fetchCarrierDropdown();
      } else {
        enqueueSnackbar(res.data.msg, { variant: "error" });
      }
    } catch (error) {
      console.error("Error adding location:", error);
      enqueueSnackbar("Network error: Could not add location", {
        variant: "error",
      });
    }
  };

  const handleAddCarrier = async (e) => {
    e.preventDefault();
    if (selectedCarriers.trim() === "" || carrierGroupName.trim() === "") {
      enqueueSnackbar("Please fill all the fields", {
        variant: "warning",
      });
      return;
    }
    try {
      const res = await addCarrierGroup({
        data: selectedCarriers,
        name: carrierGroupName.trim(),
      });

      if (res?.data?.httpStatusCodes === 200) {
        enqueueSnackbar(res.data.msg, { variant: "success" });
        handleCloseAddCarrier();
        fetchCarrierDropdown();
      } else {
        enqueueSnackbar(res.data.msg, { variant: "error" });
      }
    } catch (error) {
      console.error("Error adding location:", error);
      enqueueSnackbar(`Network error: Could not add location`, {
        variant: "error",
      });
    }
  };

  const handleEditCarrier = async (e) => {
    e.preventDefault();
    try {
      if (selectedCarriers.trim() === "" || carrierGroupName.trim() === "") {
        enqueueSnackbar("Please fill all the fields", {
          variant: "warning",
        });
        return;
      }

      const res = await editCarrier(editCarrierId, {
        data: selectedCarriers,
        name: carrierGroupName.trim(),
      });
      if (res?.data?.httpStatusCodes === 200) {
        enqueueSnackbar(res.data.msg, { variant: "success" });
        handleCloseEditCarrier();
        fetchCarrierDropdown();
      } else {
        enqueueSnackbar(res.data.msg, { variant: "error" });
      }
    } catch (error) {
      console.error("Error adding location:", error);
      enqueueSnackbar("Network error: Could not add location", {
        variant: "error",
      });
    }
  };

  const handleEditFeeRule = async (data) => {
    try {
      const res = await editFeeRule(editFeeRuleId, data);
      if (res?.data?.httpStatusCodes === 200) {
        enqueueSnackbar(res.data.msg, { variant: "success" });
        handleCloseAddFeeRule();
        setEditFeeRuleId(null);
        fetchCarrierDropdown();
      } else {
        enqueueSnackbar(res.data.msg, { variant: "error" });
      }
    } catch (error) {
      console.error("Error Editing fee rule:", error);
      enqueueSnackbar("Network error: Could not edit fee rule", {
        variant: "error",
      });
    }
  };

  const onSubmit = async (data) => {
    console.log("data", data);
    const payload = {
      carrier: data?.carrier,
      sequenceNum: +data?.sequenceNum,
      travelDateEffective: data?.travelDateEffective,
      travelDateDiscontinue: data?.travelDateDiscontinue,
      ticketingDateEffective: data?.ticketingDateEffective,
      ticketingDateDiscontinue: data?.ticketingDateDiscontinue,
      origin: data?.origin,
      destination: data?.destination,
      feeAmount:
        data?.suppress || data?.oncePerCheck
          ? null
          : data?.discountType === "+"
          ? `${data?.feeAmtCrr}${data?.feeAmtPrice}`
          : `${data?.feeAmtCrr}${data?.discountType}${data?.feeAmtPrice}`,
      oncePerBookingFeeAmount:
        data?.suppress || !data?.oncePerCheck
          ? null
          : `${data?.oncePerBookingFeeAmtCurr}${data?.oncePerBookingFeeAmtPrice}`,
      feePercent:
        data?.suppress || data?.oncePerCheck
          ? null
          : data?.feePercentDiscount === "+"
          ? `${data?.feePercentPrice}`
          : `${data?.feePercentDiscount}${data?.feePercentPrice}`,
      suppress: data?.suppress,
      minPrice: data?.oncePerCheck
        ? null
        : `${data?.minPriceCurr}${data?.minPriceAmt}`,
      maxPrice: data?.oncePerCheck
        ? null
        : `${data?.maxPriceCurr}${data?.maxPriceAmt}`,
      tripType: data?.tripType,
      cabinClass: data?.cabinClass,
      cabinClassMatchMode: data?.cabinClassMatchMode,
      passengerType: data?.passengerType,
      interline: data?.interline,
      sliceInterline: data?.sliceInterline,
      minSegments: +data?.minSegments,
      minTotalSegments:
        data?.minTotalSegments === "" ? "" : +data?.minTotalSegments,
      maxHoursToDeparture:
        data?.maxHoursToDeparture !== "" ? +data?.maxHoursToDeparture : "",
      priceSource: data?.priceSource,
      status: data?.status,
    };

    if (editFeeRuleId) {
      handleEditFeeRule(payload);
    } else {
      try {
        const res = await addFeeRule(payload);
        if (res?.data?.httpStatusCodes === 200) {
          enqueueSnackbar(res.data.msg, { variant: "success" });
          handleCloseAddFeeRule();
          setEditFeeRuleId(null);
          setDuplicateFeeRuleId(null);
          fetchCarrierDropdown();
        } else {
          enqueueSnackbar(res.data.msg, { variant: "error" });
        }
      } catch (error) {
        console.error("Error adding location:", error);
        enqueueSnackbar("Network error: Could not add location", {
          variant: "error",
        });
      }
    }
  };

  const handleDeleteFeeRule = async (id) => {
    try {
      const res = await deleteFeeRule(id);
      if (res?.data?.httpStatusCodes === 200) {
        enqueueSnackbar(res.data.msg, { variant: "success" });
        fetchCarrierDropdown();
      } else {
        enqueueSnackbar(res.data.msg, { variant: "error" });
      }
    } catch (error) {
      console.error("Error deleting fee rule:", error);
      enqueueSnackbar("Network error: Could not delete fee rule", {
        variant: "error",
      });
    }
  };

  //   Context Value
  const contextValue = {
    locationDropdown,
    carrierDropdown,
    setSelectedLocations,
    selectedLocations,
  };

  const handleDownload = async () => {
    try {
      const res = await downloadFile();
      if (res?.status === 200) {
        enqueueSnackbar("File Downloaded", { variant: "success" });
      }
    } catch (error) {
      enqueueSnackbar("Network error: Could not download file", {
        variant: "error",
      });
    }
  };

  const handleSearch = (e) => {
    setFieldSearchText(e.target.value);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(fieldSearchText);
    }, 300); // 300ms debounce

    return () => clearTimeout(handler);
  }, [fieldSearchText]);

  useEffect(() => {
    const lowerSearch = debouncedSearch.toLowerCase();

    const filteredData = allFeeRulesList?.filter((item) => {
      return (
        item.sequenceNum?.toString().includes(lowerSearch) ||
        item.carrier?.toLowerCase().includes(lowerSearch) ||
        getCarrierName(carrierDropdown3, item.carrier)
          ?.toLowerCase()
          .includes(lowerSearch) ||
        (item.status && lowerSearch === "active") ||
        (!item.status && lowerSearch === "inactive") ||
        item.origin?.toLowerCase().includes(lowerSearch) ||
        item.destination?.toLowerCase().includes(lowerSearch) ||
        item.cabinClass?.toLowerCase().includes(lowerSearch) ||
        item.travelDateEffective?.toLowerCase().includes(lowerSearch) ||
        item.travelDateDiscontinue?.toLowerCase().includes(lowerSearch) ||
        item.feePercent?.toString().includes(lowerSearch) ||
        item.feeAmount?.toString().includes(lowerSearch) ||
        (item.suppress ? "true" : "false").includes(lowerSearch) ||
        item.ticketingDateEffective?.toLowerCase().includes(lowerSearch) ||
        item.ticketingDateDiscontinue?.toLowerCase().includes(lowerSearch) ||
        item.oncePerBookingFeeAmount?.toString().includes(lowerSearch) ||
        item.tripType?.toLowerCase().includes(lowerSearch) ||
        item.cabinClassMatchMode?.toLowerCase().includes(lowerSearch) ||
        item.passengerType?.toLowerCase().includes(lowerSearch) ||
        item.minPrice?.toString().includes(lowerSearch) ||
        item.maxPrice?.toString().includes(lowerSearch) ||
        item.interline?.toString().toLowerCase().includes(lowerSearch) ||
        item.sliceInterline?.toString().toLowerCase().includes(lowerSearch) ||
        item.minSegments?.toString().includes(lowerSearch) ||
        item.minTotalSegments?.toString().includes(lowerSearch) ||
        item.maxHoursToDeparture?.toString().includes(lowerSearch) ||
        item.priceSource?.toLowerCase().includes(lowerSearch)
      );
    });

    setFeeRulesList(filteredData);
  }, [debouncedSearch, allFeeRulesList, carrierDropdown3]);
  const openDocument = (url) => {
    window.open(url, "_blank");
  };

  const addRuleInCRMHandler = async () => {
    setEnteredCaptcha(null);
    try {
      const res = await addRuleIn();
      console.log(res);
      if (res.data.msg == "success") {
        enqueueSnackbar(res.data.msg, { variant: "success" });
      } else {
        enqueueSnackbar(res.data.msg, { variant: "warning" });
      }
    } catch (error) {
      enqueueSnackbar("Network error: Could not add rule in CRM", {
        variant: "error",
      });
    }
    setAddRuleInCRM(false);

    setCaptcha(null);
  };
  return (
    <GfsContext.Provider value={contextValue}>
      <Container maxWidth={false}>
        <Typography
          variant="h3"
          component="h2"
          sx={{ mb: 4, fontSize: { xs: 24, sm: 32 } }}
        >
          GFS Rules
        </Typography>

        <Box
          component="div"
          sx={{ Width: 100, p: 3, boxShadow: 4, borderRadius: 1 }}
        >
          <Row>
            <Col md={12} lg={12} xl={11}>
              <Row className="mb-5">
                <Col sm={6} md={6}>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ mb: 2, fontSize: 16, fontWeight: "500" }}
                  >
                    Location Group
                  </Typography>
                </Col>
                <Col sm={6} md={6} className="text-sm-end text-start">
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: "#4B7BCF",
                      boxShadow: 0,
                      color: "#fff",
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "#2d65c7",
                      },
                    }}
                    onClick={handleShowAddLocation}
                  >
                    <AddIcon />
                    &nbsp; Add New Location Group
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>

          {loading ? (
            <SpinnerLoader />
          ) : locationList?.length > 0 ? (
            locationList?.map((item, index) => {
              const val = item?.locationList?.map((loc) => loc?.id).join(", ");
              return (
                <Row className="mt-0">
                  <Col sm={3} md={3} lg={3} xl={3}>
                    <TextField
                      id="outlined-read-only-input"
                      label="Location Group Name"
                      value={item.name} // use value instead of defaultValue
                      inputProps={{ readOnly: true }}
                      sx={{
                        width: "100%",
                        fontSize: 14,
                        marginBottom: "25px",
                        "& label.Mui-focused": {
                          color: "#4B7BCF",
                        },
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: "#4B7BCF",
                          },
                        },
                      }}
                    />
                  </Col>

                  <Col sm={7} md={7} lg={7} xl={7}>
                    <TextField
                      id="outlined-read-only-input"
                      label="Location Code"
                      value={val}
                      inputProps={{ readOnly: true }}
                      sx={{
                        width: "100%",
                        fontSize: 14,
                        color: "#111111",
                        marginBottom: "25px",
                        "& label.Mui-focused": {
                          color: "#4B7BCF",
                        },
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: "#4B7BCF",
                          },
                        },
                      }}
                      required
                    />
                  </Col>
                  <Col sm={2} md={2} lg={2} xl={2}>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{
                        backgroundColor: "#F4F4F4",
                        boxShadow: 0,
                        fontSize: 14,
                        color: "#111111",
                        fontWeight: "400",
                        borderRadius: 1,
                        marginBottom: "25px",
                        "&:hover": {
                          backgroundColor: "#eeeeee",
                        },
                      }}
                      onClick={() => handleShowEditLocation(item)}
                    >
                      <EditPancilIcon />
                      &nbsp;Edit
                    </Button>
                  </Col>
                </Row>
              );
            })
          ) : (
            <p className=" text-danger mt-3">No Location Group Found</p>
          )}
        </Box>

        <Box
          component="div"
          sx={{ Width: 100, p: 3, boxShadow: 4, mt: 4, borderRadius: 1 }}
        >
          <Row>
            <Col lg={12} xl={11}>
              <Row className="mb-5">
                <Col sm={6} md={6}>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ mb: 2, fontSize: 16, fontWeight: "500" }}
                  >
                    Carrier Group
                  </Typography>
                </Col>
                <Col sm={6} md={6} className="text-sm-end text-start">
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{
                      backgroundColor: "#4B7BCF",
                      boxShadow: 0,
                      color: "#fff",

                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "#2d65c7",
                      },
                    }}
                    onClick={handleShowAddCarrier}
                  >
                    <AddIcon />
                    &nbsp; Add New Carrier Group
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>

          {loading ? (
            <SpinnerLoader />
          ) : carrierList?.length > 0 ? (
            carrierList?.map((item, index) => {
              const val = item?.carriers?.map((carr) => carr?.id).join(", ");
              return (
                <Row className="mt-0">
                  <Col sm={6} md={3} lg={3} xl={3}>
                    <TextField
                      id="outlined-required"
                      label="Carrier Group Name"
                      value={item.name}
                      inputProps={{ readOnly: true }}
                      sx={{
                        width: "100%",
                        height: 40,
                        fontSize: 14,
                        marginBottom: "25px",
                        "& label.Mui-focused": {
                          color: "#4B7BCF",
                        },
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: "#4B7BCF",
                          },
                        },
                      }}
                      required
                    />
                  </Col>
                  <Col sm={9} md={7} lg={7} xl={7}>
                    <TextField
                      id="outlined-required"
                      label="Carrier Code"
                      value={val}
                      inputProps={{ readOnly: true }}
                      sx={{
                        width: "100%",
                        fontSize: 14,
                        color: "#111111",
                        marginBottom: "25px",
                        "& label.Mui-focused": {
                          color: "#4B7BCF",
                        },
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: "#4B7BCF",
                          },
                        },
                      }}
                      required
                    />
                  </Col>
                  <Col sm={3} md={2} lg={2} xl={2}>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{
                        backgroundColor: "#F4F4F4",
                        boxShadow: 0,
                        fontSize: 14,
                        color: "#111111",
                        fontWeight: "400",
                        borderRadius: 1,
                        marginBottom: "25px",
                        "&:hover": {
                          backgroundColor: "#eeeeee",
                        },
                      }}
                      onClick={() => handleShowEditCarrier(item)}
                    >
                      <EditPancilIcon />
                      &nbsp;Edit
                    </Button>
                  </Col>
                </Row>
              );
            })
          ) : (
            <p className=" text-danger mt-3">No Carrier Group Found</p>
          )}
        </Box>

        <Box
          component="div"
          sx={{ Width: 100, p: { xs: "5px", sm: 3 }, mt: 4, borderRadius: 1 }}
        >
          <Row className="align-items-center">
            <Col sm={12} md={4} lg={4}>
              <Typography
                variant="h6"
                component="h6"
                sx={{ mb: 2, fontSize: 16, fontWeight: "500" }}
              >
                Fee Rule
              </Typography>
            </Col>
            <Col sm={12} md={8} lg={8}>
              <div className="searchaddbtn d-flex flex-wrap justify-content-start justify-content-sm-end gap-2 mb-3">
                <div className="free-rule-search">
                  <span className="search-icon">
                    <SearchIcon />
                  </span>
                  <input
                    value={fieldSearchText}
                    onChange={(e) => handleSearch(e)}
                    type="text"
                    placeholder="Search"
                  />
                </div>
                <Button
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#4B7BCF",
                    boxShadow: 0,
                    color: "#fff",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#2d65c7",
                    },
                  }}
                  onClick={handleShowAddFeeRule}
                >
                  <AddIcon />
                  &nbsp; Add Fee Rules
                </Button>
                <Button
                  type="button"
                  disabled={feeRulesList?.length === 0}
                  onClick={handleDownload}
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#00AB55",
                    boxShadow: 0,
                    color: "#fff",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#018f48ff",
                    },
                  }}
                >
                  <i className="fas fa-download me-2"></i> Download
                </Button>
                <Button
                  type="button"
                  disabled={true}
                  //   onClick={handleDownload}
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#00AB55",
                    boxShadow: 0,
                    color: "#fff",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#018f48ff",
                    },
                  }}
                >
                  <i className="fas fa-upload me-2"></i> Upload
                </Button>

                <button
                  type="button"
                  className="btn btn-primary btn-md feedocsuport"
                  onClick={() => openDocument("/ita-help.html")}
                >
                  Fee Doc
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-md feedocsuport"
                  onClick={() => openDocument("/supported-airlines.pdf")}
                >
                  Supported Airlines
                </button>

                <Button
                  type="button"
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#00AB55",
                    boxShadow: 0,
                    color: "#fff",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "#018f48ff",
                    },
                  }}
                  onClick={() => setAddRuleInCRM(true)}
                >
                  Add Rule In CRM
                </Button>
              </div>
            </Col>
          </Row>
          {loading ? (
            <SpinnerLoader />
          ) : (
            <FeeRuleCard
              feeRulesList={feeRulesList}
              editFeeRuleId={editFeeRuleId}
              setEditFeeRuleId={setEditFeeRuleId}
              handleShowAddFeeRule={handleShowAddFeeRule}
              reset={reset}
              handleDeleteFeeRule={handleDeleteFeeRule}
              carrierDropdown3={carrierDropdown3}
              fetchCarrierDropdown={fetchCarrierDropdown}
              setDuplicateFeeRuleId={setDuplicateFeeRuleId}
              duplicateFeeRuleId={duplicateFeeRuleId}
            />
          )}
        </Box>
      </Container>

      {/*--------------- Add New Location Modal    ------------*/}
      <Modal
        show={showAddLocation}
        onHide={handleCloseAddLocation}
        centered
        size="lg"
        style={{ borderRadius: 10 }}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Box sx={{ px: 2 }}>
            <Typography
              variant="h6"
              component="h6"
              sx={{ mb: 2, fontSize: 16, fontWeight: "500", mb: 3 }}
            >
              Add New Location
            </Typography>
            <form onSubmit={(e) => handleAddLocation(e)}>
              <Row className="mt-0">
                <Col md={4} lg={4} className="mb-4">
                  <TextField
                    sx={{
                      width: "100%",
                      "& label.Mui-focused": {
                        color: "#4B7BCF",
                      },
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: "#4B7BCF",
                        },
                      },
                    }}
                    id="outlined-required"
                    label="Location Group Name"
                    value={locationGroupName}
                    onChange={(e) => setLocationGroupName(e.target.value)}
                    required
                  />
                </Col>

                <Col md={8} lg={8} className="mb-4">
                  <MultiSelectWithSearch
                    dropDownList={locationDropdown}
                    selectedList={selectedLocations}
                    setSelectedList={setSelectedLocations}
                    label="Location"
                  />
                </Col>
                <Col sm={12} className="text-sm-end text-start mb-3">
                  <Button
                    variant="contained"
                    type="submit"
                    size="medium"
                    sx={{
                      backgroundColor: "#4B7BCF",
                      width: "180px",
                      fontSize: 14,
                      fontWeight: "400",
                      boxShadow: 0,
                      color: "#fff",
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "#2d65c7",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </form>
          </Box>
        </Modal.Body>
      </Modal>
      {/*---------------// Add New Location Modal end ------------*/}

      {/*--------------- Edit Location Modal    ------------*/}
      <Modal
        show={showEditLocation}
        onHide={handleCloseEditLocation}
        centered
        size="lg"
        style={{ borderRadius: 10 }}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Box sx={{ px: 2 }}>
            <Typography
              variant="h6"
              component="h6"
              sx={{ mb: 2, fontSize: 16, fontWeight: "500", mb: 3 }}
            >
              Edit Location
            </Typography>
            <form onSubmit={(e) => handleEditLocation(e)}>
              <Row className="mt-0">
                <Col md={4} lg={4} className="mb-4">
                  <TextField
                    sx={{
                      width: "100%",
                      "& label.Mui-focused": {
                        color: "#4B7BCF",
                      },
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: "#4B7BCF",
                        },
                      },
                    }}
                    id="outlined-required"
                    label="Location Group Name"
                    value={locationGroupName}
                    onChange={(e) => setLocationGroupName(e.target.value)}
                    required
                  />
                </Col>

                <Col md={8} lg={8} className="mb-4">
                  <MultiSelectWithSearch
                    dropDownList={locationDropdown}
                    selectedList={selectedLocations}
                    setSelectedList={setSelectedLocations}
                    label="Location"
                  />
                </Col>
                <Col sm={12} className="text-sm-end text-start mb-3">
                  <Button
                    variant="contained"
                    type="submit"
                    size="medium"
                    sx={{
                      backgroundColor: "#4B7BCF",
                      width: "180px",
                      fontSize: 14,
                      fontWeight: "400",
                      boxShadow: 0,
                      color: "#fff",
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "#2d65c7",
                      },
                    }}
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            </form>
          </Box>
        </Modal.Body>
      </Modal>
      {/*---------------// Edit Location Modal end ------------*/}

      {/*--------------- Add New Carrier Modal    ------------*/}
      <Modal
        show={showAddCarrier}
        onHide={handleCloseAddCarrier}
        centered
        size="lg"
        style={{ borderRadius: 10 }}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Box sx={{ px: 2 }}>
            <Typography
              variant="h6"
              component="h6"
              sx={{ mb: 2, fontSize: 16, fontWeight: "500", mb: 3 }}
            >
              Add New Carrier
            </Typography>
            <form onSubmit={(e) => handleAddCarrier(e)}>
              <Row className="mt-0">
                <Col md={4} lg={4} className="mb-4">
                  <TextField
                    sx={{
                      width: "100%",
                      "& label.Mui-focused": {
                        color: "#4B7BCF",
                      },
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: "#4B7BCF",
                        },
                      },
                    }}
                    id="outlined-required"
                    label="Carrier Group Name"
                    value={carrierGroupName}
                    onChange={(e) => setCarrierGroupName(e.target.value)}
                    required
                  />
                </Col>

                <Col md={8} lg={8} className="mb-4">
                  <MultiSelectWithSearch
                    dropDownList={carrierDropdown}
                    selectedList={selectedCarriers}
                    setSelectedList={setSelectedCarriers}
                    label="Carrier Name"
                  />
                </Col>
                <Col sm={12} className="text-sm-end text-start mb-3">
                  <Button
                    variant="contained"
                    type="submit"
                    size="medium"
                    sx={{
                      backgroundColor: "#4B7BCF",
                      width: "180px",
                      fontSize: 14,
                      fontWeight: "400",
                      boxShadow: 0,
                      color: "#fff",
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "#2d65c7",
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </form>
          </Box>
        </Modal.Body>
      </Modal>
      {/*--------------- Add New Carrier Modal End------------*/}

      {/*--------------- Edit Carrier Modal    ------------*/}
      <Modal
        show={showEditCarrier}
        onHide={handleCloseEditCarrier}
        centered
        size="lg"
        style={{ borderRadius: 10 }}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Box sx={{ px: 2 }}>
            <Typography
              variant="h6"
              component="h6"
              sx={{ mb: 2, fontSize: 16, fontWeight: "500", mb: 3 }}
            >
              Edit Carrier
            </Typography>
            <form onSubmit={(e) => handleEditCarrier(e)}>
              <Row className="mt-0">
                <Col md={4} lg={4} className="mb-4">
                  <TextField
                    sx={{
                      width: "100%",
                      "& label.Mui-focused": {
                        color: "#4B7BCF",
                      },
                      "& .MuiOutlinedInput-root": {
                        "&.Mui-focused fieldset": {
                          borderColor: "#4B7BCF",
                        },
                      },
                    }}
                    id="outlined-required"
                    label="Carrier Group Name"
                    value={carrierGroupName}
                    onChange={(e) => setCarrierGroupName(e.target.value)}
                    required
                  />
                </Col>

                <Col md={8} lg={8} className="mb-4">
                  <MultiSelectWithSearch
                    dropDownList={carrierDropdown}
                    selectedList={selectedCarriers}
                    setSelectedList={setSelectedCarriers}
                    label="Carrier Name"
                  />
                </Col>
                <Col sm={12} className="text-sm-end text-start mb-3">
                  <Button
                    variant="contained"
                    type="submit"
                    size="medium"
                    sx={{
                      backgroundColor: "#4B7BCF",
                      width: "180px",
                      fontSize: 14,
                      fontWeight: "400",
                      boxShadow: 0,
                      color: "#fff",
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "#2d65c7",
                      },
                    }}
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            </form>
          </Box>
        </Modal.Body>
      </Modal>
      {/*---------------// Edit Carrier Modal end ------------*/}

      {/*--------------- Add New Free Rule Modal ------------*/}
      <Modal
        show={showAddFeeRule}
        onHide={handleCloseAddFeeRule}
        centered
        size="lg"
        style={{ borderRadius: 10 }}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <AddNewFeeRule
              register={register}
              errors={errors}
              control={control}
              airportDropdown={airportDropdown}
              dropDownList={carrierDropdown3}
              watch={watch}
              handleEditFeeRule={handleEditFeeRule}
              editFeeRuleId={editFeeRuleId}
              duplicateFeeRuleId={duplicateFeeRuleId}
            />
          </form>
        </Modal.Body>
      </Modal>

      {/*--------------- Ruking CRM Modal ------------*/}
      <Modal
        show={addRuleInCRM}
        onHide={() => setAddRuleInCRM(false)}
        centered
        size="md"
      >
        <Modal.Header closeButton />
        <Modal.Body className="text-center">
          <p className="mb-2 text-black font-normal ">
            Are you sure you want to ADD Rule In CRM ?
          </p>
          <p className="mb-4 text-danger small">
            <strong>Note:</strong> These rules will directly impact Google
            (GFS). Please ensure that the applied rules are reviewed, corrected,
            and tested.
          </p>
          <div className="mb-4">
            <p>
              Please Enter this Number:
              <strong style={{ letterSpacing: "2px" }}> {captcha}</strong>
            </p>
            <input
              style={{ letterSpacing: "1px" }}
              value={enteredCaptcha}
              type="text"
              onChange={(e) => setEnteredCaptcha(e.target.value)}
              placeholder="Enter Above Number"
              className="p-1 border-2 border-gray-300 rounded-md"
            />
          </div>
          <div className="d-flex justify-content-center gap-3">
            <Button
              type="button"
              disabled={String(captcha) !== enteredCaptcha}
              onClick={addRuleInCRMHandler}
              variant="contained"
              size="medium"
              sx={{
                backgroundColor: "#00AB55",
                boxShadow: 0,
                color: "#fff",
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "#018f48ff",
                },
              }}
            >
              Submit
            </Button>
            <Button
              onClick={() => setAddRuleInCRM(false)}
              type="button"
              variant="contained"
              size="medium"
              sx={{
                backgroundColor: "#e0140dff",
                boxShadow: 0,
                color: "#fff",
                borderRadius: 1,
                "&:hover": {
                  backgroundColor: "#bd3826ff",
                },
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/*--------------- Add New Free Rule Modal  ------------*/}
    </GfsContext.Provider>
  );
};

export default GFSRules;
